import React from 'react';
import { Calendar } from 'primereact/calendar';
import PropTypes from 'prop-types';

export default class DateSelector extends React.Component {
  render() {
    const { label, value, onDateSelect, width = 160 } = this.props;

    return (
      <div className="DataRangeSelector">
        
        {/* CSS LOCAL – aplicado somente a este componente */}
        <style>
          {`
            /* Input fechado */
            .tele-calendar .p-inputtext {
              font-size: 14px !important;
              padding: 6px 10px !important;
              height: 40px !important;
            }

            /* Ícone do calendário */
            .tele-calendar .p-datepicker-trigger {
              height: 40px !important;
            }

            /* Popup do calendário */
            .tele-calendar-panel .p-datepicker {
              font-size: 14px !important;
            }

            .tele-calendar-panel .p-datepicker-calendar td {
              padding: 4px !important;
            }

            /* Label */
            .tele-calendar-label {
              top: -0.75em;
              font-size: 12px;
            }
          `}
        </style>

        <span className="p-float-label">
          <Calendar
            inputId="date"
            value={value}
            onChange={(e) => onDateSelect(e.value)}
            showButtonBar
            dateFormat="yy-mm-dd"
            style={{ width }}
            className="tele-calendar"
            panelClassName="tele-calendar-panel"
          />
          <label className="tele-calendar-label">{label}</label>
        </span>

      </div>
    );
  }
}

DateSelector.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onDateSelect: PropTypes.func,
  width: PropTypes.number
};
